<script>
// import jsPDF from "jspdf";
import appConfig from "@/app.config";
import axios from 'axios';
export default {
  page: {
    title: "View Chat",
  },
  data() {
    return {
      currrentUser: [],
      pending: false,
    };
  },
  components: {},
  methods: {
    async getCurrentUser() {
      // let that = this;
      await axios
        .get(appConfig.chat_history.view + this.$route.params.id)
        .then(function (response) {
          console.log(response)
          // that.currrentUser = response.data.chat_history;
          // let pdfName = "chat";
          // var doc = new jsPDF();
          // doc.fromHTML(document.getElementById("print"), 15, 15, {
          //   width: 170,
          // });
          // doc.save(pdfName + ".pdf");
        });
    },
  },
  created() {
    this.pending = true;
    axios.all([this.getCurrentUser()]).finally(() => (this.pending = false));
  },
};
</script>
<template>
  <div id="print">
    <!--  -->
    <div class="outerbg">
      <div class="chatboxout">
        <div class="logo">
          <img src="https://i.ibb.co/34gt7xJ/logo-light.pngg" />
        </div>
        <div class="chatboxin">
          <div v-for="item in currrentUser" :key="item">
            <div v-if="item.type === 'User'" class="chat-container agent">
              <div class="agentName">
                <strong>{{ item.name }}</strong>
              </div>
              <div class="msg">
                <div class="chatmsg">
                  {{ item.text }}
                </div>
              </div>
              <div class="date">{{ item.created_at }}</div>
            </div>
            <!--  -->
            <div v-if="item.type === 'Bot'" class="chat-container bot">
              <div class="chat-respond botName">
                <strong>{{ item.name }}</strong>
              </div>
              <div class="chat-respond msg">
                <div class="flippd">
                  <div class="chatmsg">
                    {{ item.text }}
                  </div>
                </div>
              </div>
              <div class="date">2021-09-12 03:05 PM</div>
            </div>
            <!--  -->
          </div>
        </div>
      </div>
    </div>
    <!--  -->
  </div>
</template>
<style scoped>
.logo {
  text-align: center;
}

.agent {
  text-align: right;
  position: relative;
}

.bot {
  text-align: left;
}

.agentName {
  display: block;
  text-transform: capitalize;
  font-size: 0.9rem;
  margin-bottom: 0.3rem;
}

.botName {
  display: block;
  color: #f48806;
  text-transform: capitalize;
  font-size: 0.9rem;
  margin-bottom: 0.3rem;
}

.date {
  display: block;
  font-size: 0.8rem;
}

.outerbg {
  width: 100%;
  max-width: 80%;
  margin: 20px;
  padding: 30px 0;
  margin: 0 auto;
  background: url("https://s24.postimg.org/63armx1h1/sahil_sahil_chatsbg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.chatboxout {
  font-family: open sans;
  font-size: 12px;
  line-height: 17px;
  box-sizing: border-box;
  max-width: 100%;
  margin: 0 auto;
  padding: 10px;
  background: #fff;
  border-radius: 5px;
  -webkit-box-shadow: 4px 4px 20px -1px rgba(59, 59, 59, 0.6);
  -moz-box-shadow: 4px 4px 20px -1px rgba(59, 59, 59, 0.6);
  box-shadow: 4px 4px 20px -1px rgba(59, 59, 59, 0.6);
}

.chatboxin {
  box-sizing: border-box;
  border: 1px solid rgba(208, 208, 208, 1);
  border-radius: 5px;
  padding: 5px 15px;
  font-size: 1.1rem;
}

.chat-sender.msg {
  padding: 9px 9px;
  padding-left: 21px;
  background-color: #5d5d5d;
  color: #fff;
  box-sizing: border-box;
  width: calc(100% - 53px);
  margin-left: -9px;
}

.agent .chatmsg {
  padding: 9px 9px;
  padding-left: 21px;
  background-color: #5d5d5d;
  color: #fff;
  box-sizing: border-box;
  max-width: 70%;
  width: fit-content;
  margin-top: 5px;
  float: right;
}

.agent .date {
  width: 100%;
  overflow: hidden;
}

.chat-container {
  margin-top: 15px;
  margin-bottom: 15px;
  animation: fadein 2s;
  -moz-animation: fadein 2s;
  /* Firefox */
  -webkit-animation: fadein 2s;
  /* Safari and Chrome */
  -o-animation: fadein 2s;
  /* Opera */
}

.chat-respond.msg {
  padding: 9px 9px;
  padding-left: 21px;
  background-color: #e6e6e6;
  color: #333;
  box-sizing: border-box;
  margin-right: -9px;
  transform: scale(-1, 1);
  -moz-transform: scale(-1, 1);
  -webkit-transform: scale(-1, 1);
  -o-transform: scale(-1, 1);
  -ms-transform: scale(-1, 1);

  max-width: 70%;
  width: fit-content;
}

.chat-respond.msg strong {
  color: #f48806;
}

.flippd {
  width: 100%;
  transform: scale(-1, 1);
  -moz-transform: scale(-1, 1);
  -webkit-transform: scale(-1, 1);
  -o-transform: scale(-1, 1);
  -ms-transform: scale(-1, 1);
}

@keyframes fadein {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@-moz-keyframes fadein {
  /* Firefox */
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@-webkit-keyframes fadein {
  /* Safari and Chrome */
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@-o-keyframes fadein {
  /* Opera */
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
</style>
